import React from "react";
import { IoSearch } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa";
import { BsCalendar2MinusFill } from "react-icons/bs";
import { MdPrivacyTip } from "react-icons/md";
import { cufrontLogos } from "../../cufront-assets/logos/Logos";
import Heading from "../components/Heading";
import { useNavigate } from "react-router-dom";
const HelpCenter = () => {
  const navigate = useNavigate();
  return (
    <div className="p-4 px-6 h-screen">
      <Heading />
      <div className="mt-8 w-full flex justify-center items-center  py-4">
        <div className="">
          <div className="text-[40px]">How can I help you?</div>
          <div className="h-[47px] w-[688px] border border-black rounded-full flex items-center justify-center px-2 mt-10 gap-2 overflow-hidden">
            <IoSearch size={20} />
            <input placeholder="search" className="flex-1 px-2 outline-none" />
          </div>
        </div>
      </div>
      <div className="mt-8 max-w-[1408px]  m-auto flex justify-center items-center flex-wrap gap-4">
        <div className="flex-1 p-2 py-4 h-full border border-[#000000] rounded">
          <div className="text-2xl flex items-center gap-4">
            <FaArrowRight />
            <span>Get Started</span>
          </div>
          <div className="mt-2 ml-1">
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
          </div>
        </div>
        <div className="flex-1 p-2 py-4 h-full border border-[#000000] rounded">
          <div className="text-2xl flex items-center gap-4">
            <BsCalendar2MinusFill />
            <span>Appointments</span>
          </div>
          <div className="mt-2 ml-1">
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
          </div>
        </div>
        <div className="flex-1 p-2 py-4 h-full border border-[#000000] rounded">
          <div className="text-2xl flex items-center gap-4">
            <MdPrivacyTip />
            <span>Privacy and Security</span>
          </div>
          <div className="mt-2 ml-1">
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
            <div className="mt-2">Lorem Ipsum</div>
          </div>
        </div>
      </div>
      <div className="w-full h-[126px] flex justify-center items-center gap-4 border mt-8 bg-[#C7EAC9]">
        <div className="text-[40px]">Still need help?</div>
        <button
          className="h-[42px] rounded-full border border-[#000000] text-sm px-6"
          onClick={() => navigate("/new/settings/help-center/form")}
        >
          Contact us
        </button>
      </div>
      <div className="flex justify-center items-center gap-4 mt-10">
        <div className="w-[364.5px] rounded-lg h-[268.65px] flex justify-between flex-col p-4 gap-2 border border-black">
          <div className="h-[91.33px]">
            <img
              className="h-full object-contain"
              src={cufrontLogos.cufrontLogomark}
              alt=""
            />
          </div>
          <div className="text-[18.9px]">© 2024 by Cufront Healthcare. </div>
        </div>
        <div className="bg-black text-white text-[18.9px] w-[364.5px] rounded-lg h-[268.65px] flex justify-between flex-col p-4  gap-2 border border-black">
          <div className="h-[91.33px] ">Contact</div>
          <div className="text-[18.9px] leading-[21.73px]">
            <div>
              info@mysite.com <br />
              123-456-7890 <br /> 500 Terry Francois Street, San Francisco, CA
              94158
            </div>
          </div>
        </div>
        <div className="w-[364.5px] text-[18.9px] bg-[#C7EAC9] rounded-lg h-[268.65px] flex justify-between flex-col p-4 py-4 gap-2 border border-black">
          <div className="h-[91.33px]">Social</div>
          <div>
            <div>Instagram</div>
            <div>FaceBook</div>
            <div>Linkedin</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
